module.exports = __webpack_public_path__ + "img/problem1.0c95f0e4.png";